var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comment-list"},[_c('error',{attrs:{"errors":_vm.authorError}}),_c('author-poster-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }